import View from "../framework/view";
import Server from "../server";
import template from "../../pugc/cardprint";
import {formatTimestamp} from "../misc/dates";

const classname = "cardprint-view";

const server = Server.instance();

export class CardPrintView extends View {

    private data: any;

    constructor() {
        super(classname);
        this.init();
    }

    async init() {
        this.data = await server.getCardPrint();
        this.update();
    }

    render0() {
        const data = {
            data: this.data,
            formatTimestamp: formatTimestamp,
        };

        const out = this.pug(template, data);
        return out;
    }

}
